import { createLegalDocumentMutationActions } from './legalDocumentMutationActions';
import { createLegalDocumentReadActions } from './legalDocumentReadActions';
import type {
  DocumentActions,
  DocumentRuntime,
  GetAdminStore,
  SetAdminStore,
} from './legalDocumentStoreRuntime';

export const createLegalDocumentStoreActions = (
  set: SetAdminStore,
  get: GetAdminStore
): DocumentActions => {
  const runtime: DocumentRuntime = {
    detailGeneration: 0,
    mutationIdentity: null,
    listController: null,
    summaryGeneration: 0,
  };
  return {
    ...createLegalDocumentReadActions(set, runtime),
    ...createLegalDocumentMutationActions(set, get, runtime),
  };
};
